/** Sin tildes ni diéresis: "Área" queda "Area". Para comparar o indexar texto escrito a mano. */
export function sinTildes(texto: string): string {
  return texto.normalize("NFD").replace(/[̀-ͯ]/g, "");
}
